<template>
  <div :key="route.path">
    <business-intelligence v-if="dynamicBIConfig.isShow" />
    <dynamic-table
      v-if="dynamicTableConfig.isShow"
      :displayKey="dynamicTableConfig.displayKey"
      :queryId="dynamicTableConfig.queryId"
      :displayId="dynamicTableConfig.displayId"
      :queryDataKey="dynamicTableConfig.queryDataKey"
      :isCreate="dynamicTableConfig.isCreate"
    />
  </div>
</template>

<script>
  import { BCard, BRow, BCol } from 'bootstrap-vue';
  import vSelect from 'vue-select';
  import Ripple from 'vue-ripple-directive';
  import BusinessIntelligence from './components/BusinessIntelligence.vue';
  import DynamicTable from '@/views/components/dynamic-table/DynamicTable.vue';

  import { useRouter } from '@/@core/utils/utils';

  import useDataManagementList from './hooks/useDataManagementList';

  export default {
    directives: {
      Ripple,
    },
    components: {
      BCard,
      BRow,
      BCol,
      vSelect,
      BusinessIntelligence,
      DynamicTable,
    },
    setup() {
      const { dynamicBIConfig, dynamicTableConfig } = useDataManagementList();
      const { route } = useRouter();

      return {
        dynamicBIConfig,
        dynamicTableConfig,
        route,
      };
    },
  };
</script>

<style scoped>
  @import '~@/assets/css/pages/data-management.css';
</style>
